import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { GlobalService } from './global.service';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    // Live 
    Url = "https://msldata.multilinesecurities.com/api/";
    //  Url = "http://localhost:31755/api/";

    // http://localhost:31755/

    // Local
    // Url = "http://localhost:6458/api/";
    // Url = "http://localhost:31755/api/";


    DocumentDownloadURL = "https://msldata.multilinesecurities.com/api/";
    // Url = "http://localhost:31755/api/";
    // DocumentDownloadURL = "https://mslssl.oneworldkey.com/api/";
    //Url = "https://mslssl.oneworldkey.com/api/";
    // DocumentDownloadURL = "https://mslssl.oneworldkey.com/api/";

    constructor(public global: GlobalService, public ls: LocalStorageService, private http: HttpClient) { }

    FetchTickerData() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'DS_Market_Data/getTicker')
                    .subscribe((result) => {
                        //console.log(result);
                        let res: any = result;
                        let tk = JSON.parse(res);
                        return resolve(tk);
                    }, (error) => {
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }
    FetchVolumeLeaderData() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'DS_Market_Data/getVolumeLeaders')
                    .subscribe((result) => {
                        //console.log(result);
                        let res: any = result;
                        let vl = JSON.parse(res);
                        return resolve(vl);
                    }, (error) => {
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }
    FetchTopGainerData() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'DS_Market_Data/getTopGainers')
                    .subscribe((result) => {
                        // console.log(result);
                        let res: any = result;
                        let tg = JSON.parse(res);
                        return resolve(tg);
                    }, (error) => {
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }
    FetchTopLoserData() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'DS_Market_Data/getTopLosers')
                    .subscribe((result) => {
                        // console.log(result);
                        let res: any = result;
                        let tl = JSON.parse(res);
                        return resolve(tl);
                    }, (error) => {
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }
    FetchIndexData() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'DS_Market_Data/getIndexes')
                    .subscribe((result) => {
                        // console.log(result);
                        let res: any = result;
                        let ix = JSON.parse(res);
                        return resolve(ix);
                    }, (error) => {
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }

    UploadDocument(FormData) {
        return new Promise((resolve, reject) => {
            this.http.post(this.Url + 'PDF/UploadDocument', FormData)
                .subscribe((result) => {
                    // alert("result")
                    console.log(result);
                    let res: any = result;
                    let schoolData = JSON.parse(res);
                    return resolve(schoolData);
                }, (error) => {
                    // alert("error");
                    return reject(error);
                    console.log(error.message);
                });
        })
    }

    PostPDFData(FormData) {
        return new Promise((resolve, reject) => {
            this.http.get(this.Url + 'PDF/CreatePDF?PDFData=' + JSON.stringify(FormData))
                .subscribe((result) => {
                    // alert("result")
                    console.log(result);
                    let res: any = result;
                    let schoolData = JSON.parse(res);
                    return resolve(schoolData);
                }, (error) => {
                    // alert("error");
                    return reject(error);
                    console.log(error.message);
                });
        })
    }

    SendMessage(data) {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'ContactUs/UserReach?ContactUs=' + data)
                    .subscribe((result) => {
                        // console.log(result);
                        debugger;
                        let res: any = result;
                        let sm = JSON.parse(res);
                        return resolve(sm);
                    }, (error) => {
                        debugger;
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }

    FetchNetCapital() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'Document/netcapital')
                    .subscribe((result) => {
                        // console.log(result);
                        debugger;
                        let res: any = result;
                        let nc = JSON.parse(res);
                        return resolve(nc);
                    }, (error) => {
                        debugger;
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }

    FetchLiquidCapital() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'Document/liquidcapital')
                    .subscribe((result) => {
                        // console.log(result);
                        debugger;
                        let res: any = result;
                        let lc = JSON.parse(res);
                        return resolve(lc);
                    }, (error) => {
                        debugger;
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }

    FetchFinancialStatement() {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'Document/financialstatement')
                    .subscribe((result) => {
                        // console.log(result);
                        debugger;
                        let res: any = result;
                        let lc = JSON.parse(res);
                        return resolve(lc);
                    }, (error) => {
                        debugger;
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }

    FetchFipiLipi(Date) {
        debugger;
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'FIPILIPI/FIPILIPI?Date=' + Date)
                    .subscribe((result) => {
                        // console.log(result);
                        debugger;
                        let res: any = result;
                        let lc = JSON.parse(res);
                        return resolve(lc);
                    }, (error) => {
                        debugger;
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }

    FetchResearchDocuments() {
        debugger;
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.Url + 'ResearchDoc/getResearchDocs')
                    .subscribe((result) => {
                        // console.log(result);
                        debugger;
                        let res: any = result;
                        let lc = JSON.parse(res);
                        return resolve(lc);
                    }, (error) => {
                        debugger;
                        console.log(error.message);
                    });
            }
            catch (error) {
                console.log(error);
                return reject(null);
            }
        });
    }

}
